<template>
    <div v-if="activeMessageGroup" class="message-group">
        <collapsible :title="activeMessageGroup.name" :starts-open="true">
            <message-item v-for="message in activeMessageGroup.messages" :key="'msg_'+message.id" @sent="updateGroup(message)" :message="message"></message-item>
        </collapsible>
    </div>
</template>

<script>
import MessageItem from "./MessageItem";
import Collapsible from "../Collapsible";
export default {
    name: "MessageGroup",
    components:{
        Collapsible,
        MessageItem
    },
    props:{
        messageGroup:{
            type: Object,
            default: null,
        }
    },
    data() {
        return {
            activeMessageGroup: null,
        }
    },
    mounted() {
        this.activeMessageGroup = {...this.messageGroup};

        setInterval(
            () => this.updateGroup,
            500
        );
    },
    methods: {
        toggleContent(){
            this.hiding = !this.hiding;
        },
        updateGroup(message){
            if(message){
                message.addReply = false;
            }
            axios.get("/api/message/group/" + this.activeMessageGroup.id).then(
                (pack) => this.loadedMessageGroup(pack.data),
                (pack) => this.loadMessageFailure(pack),
            );
        },
        loadedMessageGroup(data){
            if(data.success){
                //find the group
                this.activeMessageGroup = data.data;
                this.$forceUpdate();
            }
        },
        loadMessageFailure(pack){

        },
    }
}
</script>
